import React from 'react';
import Select from "react-select";

const Filter = ({ residents, organizationName }) => {
  const options = residents.map((resident) => ({
    value: resident.id,
    label: `${resident.name}'s Location History`
  }));

  const url = new URL(window.location.href)
  const resident_id = url.searchParams.get("resident_id")

  const [selectedOption, setSelectedOption] = React.useState(options.filter(option => option.value == resident_id)[0]);

  const onChangeOption = (option) => {
    setSelectedOption(option);

    let url = option ?
      `/organizations/${organizationName}/client_app/location_by_resident?resident_id=${option.value}` :
      `/organizations/${organizationName}/app/locations`
    window.location.href = encodeURI(url)
  }

  return (
    <div className="pl-3">
      <div className="row">
        <Select
          isClearable
          placeholder="Select Client..."
          className="col-xs-12 col-lg-4 ml-0 pl-0"
          options={options}
          value={selectedOption}
          onChange={(option) => onChangeOption(option)}
        />
      </div>
    </div>
  );
}
export default Filter;
